import api from './api';
import API_ROUTES from './apiRoutes';

const paymentService = {
  getPlans: async (role) => {
    const response = await api.get(API_ROUTES.PAYMENT.GET_PLANS, {
      headers: {
        'role': role,
      },
    });
    return response.data;
  },

  registerWithPayment: async (formData) => {
    const response = await api.post(API_ROUTES.PAYMENT.REGISTER_WITH_PAYMENT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getPaymentHistory: async () => {
    const response = await api.get(API_ROUTES.PAYMENT.PAYMENT_HISTORY);
    return response.data;
  },

  cancelSubscription: async () => {
    const response = await api.post(API_ROUTES.PAYMENT.CANCEL_SUBSCRIPTION, {});
    return response.data;
  },

  reactivateSubscription: async () => {
    const response = await api.post(API_ROUTES.PAYMENT.REACTIVATE_SUBSCRIPTION);
    return response.data;
  },

  getSubscriptionStatus: async () => {
    const response = await api.get(API_ROUTES.PAYMENT.SUBSCRIPTION_STATUS);
    return response.data;
  },
};

export default paymentService;
